import styled from 'styled-components';
import {
  Radio as MUIRadio,
  FormControlLabel as MUIFormControlLabel,
} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

export const Text = styled(Typography)`
  ${({
    theme: {
      transitions: { easing, duration },
    },
  }) => `
    transition: ${duration.standard}ms ${easing.easeInOut};
  `}
`;

export const Count = styled(Typography)`
  opacity: 0.6;
`;

export const FormControlLabel = styled(MUIFormControlLabel)`
  ${({
    theme: {
      palette,
      colors,
      transitions: { easing, duration },
    },
  }) => `
    width: 100%;
    margin: 0;

    .MuiFormControlLabel-label {
      width: 100%;
      padding: 11px 13px;
      border: 1px solid ${colors.greys.greys3};
      background-color: ${colors.greys.greys3};
      transition: ${duration.standard}ms ${easing.easeInOut};
    }

    &.Mui-disabled {
      cursor: not-allowed;

      .MuiFormControlLabel-label {
        background-color: transparent;
      }

      ${Text},
      ${Count} {
        opacity: 0.5;
        color: ${colors.greys.greys18};
      }
    }

    &:hover {
      ${Text} {
        color: ${palette.action.hover};
      }

      .MuiFormControlLabel-label {
        background-color: ${colors.greys.greys16};
      }

      .Mui-checked {
        & + * {
          background-color: ${palette.common.white};

          ${Text} {
            color: ${palette.text.primary};
          }
        }
      }
    }
  `}
`;

export const Radio = styled(MUIRadio)`
  ${({ theme: { colors } }) => `
    display: none;

    &.Mui-checked {
      & + * {
        background-color: transparent;
        border-color: ${colors.blues.blues1};
      }

      & + .MuiTypography-root {
        ${Count} {
          opacity: 1
        }
      }
    }
  `}
`;
